import React, { Fragment, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { Box } from '@mui/system';

import {
  adminActions,
  resetStatus,
  successSelector,
} from '@pharmaplan/common';

import { showSuccess } from '../../Profile/Pharmacist/PharmacistViewProfile/helper';
import { BroadcastGroupActionType } from '../../../../helpers/Constants';
import CustomBreadcrumbs from '../../../common/CustomBreadcrumbs';
import { formGenerator } from '../../../../helpers/formGenerator';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import { campaignFieldConfig, createCrumbs, editCrumbs } from './helper';
import styles from './styles';

interface ICreateEditCampaign {
  type: BroadcastGroupActionType;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  formik: FormikProps<any>;
}

const CreateEditCampaign = ({
  type,
  setCurrentStep,
  formik,
}: ICreateEditCampaign) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEdit = type === BroadcastGroupActionType.edit;

  const createSuccess = useAppSelector((store) =>
    successSelector([adminActions.createCampaign], store));
  const updateSuccess = useAppSelector((store) =>
    successSelector([adminActions.updateCampaign], store));

  const configureEmail = () => {
    setCurrentStep((prev) =>
      prev + 1);
  };

  useEffect(() => {
    if (createSuccess) {
      showSuccess(dispatch, strings.actionCompletedSuccessfully);
      dispatch(resetStatus([adminActions.createCampaign]));
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createSuccess]);

  useEffect(() => {
    if (updateSuccess) {
      showSuccess(dispatch, strings.actionCompletedSuccessfully);
      dispatch(resetStatus([adminActions.updateCampaign]));
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSuccess]);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.crumbContainer}>
        <CustomBreadcrumbs crumbs={isEdit ? editCrumbs : createCrumbs} />
      </Box>
      <Typography sx={styles.title}>
        {isEdit ? strings.editCampaign : strings.createCampaign}
      </Typography>

      <Grid container xs={12}>
        {campaignFieldConfig(formik, isEdit).map((item) => {
          const { key } = item;
          return <Fragment key={key}>{formGenerator(item, formik)}</Fragment>;
        })}
        <Grid xs={3.1} item>
          <CustomButton
            customClass={styles.uploadImage}
            label={strings.createEmailTemplate}
            onClick={configureEmail}
          />
        </Grid>
      </Grid>

      <Grid container xs={12} sx={styles.buttonContainer}>
        <CustomButton
          label={isEdit ? strings.save : strings.create}
          onClick={formik.handleSubmit}
        />
      </Grid>
    </Box>
  );
};

export default CreateEditCampaign;
